import { combineReducers } from 'redux-immutable';
import { reducer as registerReducer } from '../pages/manu/register/store';
import { reducer as forgetReducer } from '../pages/manu/forget/store';
import { reducer as loginNameReducer } from '../pages/manu/login/store';
import { reducer as loginTelReducer } from '../pages/manu/logintel/store';
import { reducer as headerReducer } from '../common/header/store';
import { reducer as listReducer } from '../pages/list/store';
import { reducer as videoReducer } from '../pages/video/store';


const reducer = combineReducers({
	forget: forgetReducer,
	register: registerReducer,
	loginn: loginNameReducer,
	logintel: loginTelReducer,
	header: headerReducer,
	list: listReducer,
	video: videoReducer,
})

export default reducer;